// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const AddToCartJewelleryExistingCustomerDocument = gql`
    mutation addToCartJewelleryExistingCustomer($input: DesignStudioJewelleryInput!) {
  createDesignStudioProductAndAddToCartJewelleryExistingCustomer(input: $input) {
    __typename
  }
}
    `;

export function useAddToCartJewelleryExistingCustomerMutation() {
  return Urql.useMutation<SchemaTypes.AddToCartJewelleryExistingCustomerMutation, SchemaTypes.AddToCartJewelleryExistingCustomerMutationVariables>(AddToCartJewelleryExistingCustomerDocument);
};